"use client"

import { AlarmClockMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlarmClockMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlarmClockMinusIcon = component(Icon)({ as: AlarmClockMinus })
